// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__10V8m","tableRow":"styles_tableRow__1jQja","sorted":"styles_sorted__YH8RM","line":"styles_line__2JBLu","docImage":"styles_docImage__4lCUy"};